export default "__VITE_ASSET__QrRRd_j9__"